<template>
    <button @click="$emit('handle-click', $event)" class="btn">
        <slot></slot>
    </button>
</template>

<script>
export default {
    emits: ['handle-click']
}
</script>

<style lang="scss" scoped>
.btn {
    background: #744111;
    border-radius: 52px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 27px;
    letter-spacing: 0.025em;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 202px;
    height: 59px;
    margin-top: 50px;
    @media (max-width: 767px) {
        font-size: 18px;
        width: 221px;
        height: 54px;
    }
}
</style>